<div class="container-xl" *ngIf="!isMobile">
    <div class="footer">
        Indosat Ooredoo Hutchison <img src="assets/img/c-icon.png" class="icon-c" /> {{currentYear}} All Right Reserved
    </div>
</div>
